
import React from 'react';
import { connect } from 'react-redux';
import LoadingComponent from './LoadingComponent';

const ShowLoader = ({loading}) => {
  return (
    <React.Fragment>{loading && <LoadingComponent />}</React.Fragment>
  );
}

export default connect((state) => ({loading: state.async.loading}))(ShowLoader);